<template>
  <div>
    <div class="center-t">
      <div class="sp-odt">参与专利池运营情况管理</div>
    </div>
    <div class="page-wrap">
      <el-button
        icon="el-icon-plus"
        type="primary"
        size="mini"
        style="margin-bottom:20px"
        @click="handleAdd"
      >添加</el-button>
      <el-table :data="tableData" stripe style="width: 100%">
        <el-table-column type="index" width="55" label="序号" align="center">
          <template slot-scope="scope">
            {{ (queryParams.pageNum - 1) * queryParams.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="operator"
          label="专利池运营方"
          width="200"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="poolName"
          label="专利池名称"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="120">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              icon="el-icon-edit"
              @click="handleEdit(scope.row.id)"
            >更新</el-button>
            <el-button
              size="mini"
              type="text"
              icon="el-icon-delete"
              @click="handleDelete(scope.row.id)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
      />
    </div>
    <poolDialog
      :pool_dialogVisible.sync="pool_dialogVisible"
      v-if="pool_dialogVisible"
      :id="id"
      @refresh="getList"
    ></poolDialog>
  </div>
</template>
<script>
import { poolList, poolDelete } from "@/api/index";
import poolDialog from "@/views/userpage/components/poolDialog";
export default {
  components: { poolDialog },
  data() {
    return {
      queryParams: {
        pageSize: 10,
        pageNum: 1
      },
      tableData: [],
      id: "",
      total: 0,
      pool_dialogVisible: false
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      poolList({ ...this.queryParams }).then(res => {
        this.tableData = res.data.list;
        this.total = res.data.total;
      });
    },
    handleEdit(id) {
      this.id = id;
      this.pool_dialogVisible = true;
    },
    handleAdd() {
      this.id = "";
      this.pool_dialogVisible = true;
    },
    handleDelete(id) {
      this.$confirm("是否确认删除该数据？", "提示", {
        confirmButtonText: "确定删除",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          poolDelete([id]).then(res => {
            this.$message({
              message: "删除成功",
              type: "success"
            });
            this.getList();
          });
        })
        .catch(err => {});
    }
  }
};
</script>
<style lang="less" scoped>
</style>